import { BLOG_OWNER_NPUB } from '@/lib/blogConfig';

export function BlogFooter() {
  return (
    <footer className="border-t border-border/60 mt-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-muted-foreground">
        <a
          href={`https://jumble.social/users/${BLOG_OWNER_NPUB}`}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary transition-colors"
        >
          Follow me on Nostr
        </a>
        <a
          href="https://shakespeare.diy"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary transition-colors"
        >
          Vibed with Shakespeare
        </a>
      </div>
    </footer>
  );
}
